import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { McpConsent } from "@/components/mcp/mcp-consent";

export const Route = createFileRoute("/mcp/authorize")({
  validateSearch: z.object({ requestId: z.uuid() }),
  beforeLoad: async ({ context: { queryClient, authOptions }, search }) => {
    const session = await queryClient.fetchQuery(authOptions.session);
    if (!session)
      throw redirect({
        to: "/auth/$authView",
        params: { authView: "sign-in" },
        search: { redirectTo: `/mcp/authorize?requestId=${search.requestId}` },
      });
  },
  component: () => (
    <main className="mx-auto w-full max-w-xl px-5 py-16">
      <McpConsent requestId={Route.useSearch().requestId} />
    </main>
  ),
});
